import { cloneObject } from '../../../utilities';

const getTooltipQuill = (_labelField, _xAxisField, _yAxisField, _fields) => {
  const tooltipQuill = {
    ops: [
      {
        attributes: {
          textShadow:
            'rgb(255, 255, 255) 0px 0px 1px, rgb(255, 255, 255) 0px 0px 1px, rgb(255, 255, 255) 0px 0px 1px, rgb(255, 255, 255) 0px 0px 1px, rgb(255, 255, 255) -1px -1px 1px, rgb(255, 255, 255) -1px 1px 1px, rgb(255, 255, 255) 1px -1px 1px, rgb(255, 255, 255) 1px 1px 1px, rgb(255, 255, 255) -2px -2px 1px, rgb(255, 255, 255) -2px 2px 1px, rgb(255, 255, 255) 2px -2px 1px, rgb(255, 255, 255) 2px 2px 1px, rgb(255, 255, 255) -3px -3px 1px, rgb(255, 255, 255) -3px 3px 1px, rgb(255, 255, 255) 3px -3px 1px, rgb(255, 255, 255) 3px 3px 1px',
        },
        insert: {
          inlineValue: {
            fieldName: _labelField,
            title: _fields[_labelField].title,
            format: _fields[_labelField].format,
          },
        },
      },
      {
        attributes: {
          textShadow:
            'rgb(255, 255, 255) 0px 0px 1px, rgb(255, 255, 255) 0px 0px 1px, rgb(255, 255, 255) 0px 0px 1px, rgb(255, 255, 255) 0px 0px 1px, rgb(255, 255, 255) -1px -1px 1px, rgb(255, 255, 255) -1px 1px 1px, rgb(255, 255, 255) 1px -1px 1px, rgb(255, 255, 255) 1px 1px 1px, rgb(255, 255, 255) -2px -2px 1px, rgb(255, 255, 255) -2px 2px 1px, rgb(255, 255, 255) 2px -2px 1px, rgb(255, 255, 255) 2px 2px 1px, rgb(255, 255, 255) -3px -3px 1px, rgb(255, 255, 255) -3px 3px 1px, rgb(255, 255, 255) 3px -3px 1px, rgb(255, 255, 255) 3px 3px 1px',
        },
        insert: ' ',
      },
      { insert: '\n' },
      {
        attributes: {
          textShadow:
            'rgb(255, 255, 255) 0px 0px 1px, rgb(255, 255, 255) 0px 0px 1px, rgb(255, 255, 255) 0px 0px 1px, rgb(255, 255, 255) 0px 0px 1px, rgb(255, 255, 255) -1px -1px 1px, rgb(255, 255, 255) -1px 1px 1px, rgb(255, 255, 255) 1px -1px 1px, rgb(255, 255, 255) 1px 1px 1px, rgb(255, 255, 255) -2px -2px 1px, rgb(255, 255, 255) -2px 2px 1px, rgb(255, 255, 255) 2px -2px 1px, rgb(255, 255, 255) 2px 2px 1px, rgb(255, 255, 255) -3px -3px 1px, rgb(255, 255, 255) -3px 3px 1px, rgb(255, 255, 255) 3px -3px 1px, rgb(255, 255, 255) 3px 3px 1px',
        },
        insert: {
          inlineValue: {
            fieldName: _xAxisField,
            title: _fields[_xAxisField].title,
            format: _fields[_xAxisField].format,
          },
        },
      },
      {
        attributes: {
          textShadow:
            'rgb(255, 255, 255) 0px 0px 1px, rgb(255, 255, 255) 0px 0px 1px, rgb(255, 255, 255) 0px 0px 1px, rgb(255, 255, 255) 0px 0px 1px, rgb(255, 255, 255) -1px -1px 1px, rgb(255, 255, 255) -1px 1px 1px, rgb(255, 255, 255) 1px -1px 1px, rgb(255, 255, 255) 1px 1px 1px, rgb(255, 255, 255) -2px -2px 1px, rgb(255, 255, 255) -2px 2px 1px, rgb(255, 255, 255) 2px -2px 1px, rgb(255, 255, 255) 2px 2px 1px, rgb(255, 255, 255) -3px -3px 1px, rgb(255, 255, 255) -3px 3px 1px, rgb(255, 255, 255) 3px -3px 1px, rgb(255, 255, 255) 3px 3px 1px',
        },
        insert: ' ',
      },
      { insert: '\n' },
      {
        attributes: {
          textShadow:
            'rgb(255, 255, 255) 0px 0px 1px, rgb(255, 255, 255) 0px 0px 1px, rgb(255, 255, 255) 0px 0px 1px, rgb(255, 255, 255) 0px 0px 1px, rgb(255, 255, 255) -1px -1px 1px, rgb(255, 255, 255) -1px 1px 1px, rgb(255, 255, 255) 1px -1px 1px, rgb(255, 255, 255) 1px 1px 1px, rgb(255, 255, 255) -2px -2px 1px, rgb(255, 255, 255) -2px 2px 1px, rgb(255, 255, 255) 2px -2px 1px, rgb(255, 255, 255) 2px 2px 1px, rgb(255, 255, 255) -3px -3px 1px, rgb(255, 255, 255) -3px 3px 1px, rgb(255, 255, 255) 3px -3px 1px, rgb(255, 255, 255) 3px 3px 1px',
        },
        insert: {
          inlineValue: {
            fieldName: _yAxisField,
            title: _fields[_yAxisField].title,
            format: cloneObject(_fields[_yAxisField].format),
          },
        },
      },
      { insert: '\n' },
    ],
  };
  return tooltipQuill;
};

export default getTooltipQuill;
